import { useToast } from '@mdvip/shared/hooks/use-toast';
import { useErrorTranslation } from '@mdvip/shared/hooks/useErrorTranslation';
import { extractGqlErrorCode } from '@mdvip/shared/lib/gqlErrors';
import { gqlRequest } from '@mdvip/shared/lib/graphql-client';
import { openExternalUrl } from '@mdvip/shared/lib/open-external-url';
import { trackException } from '@mdvip/shared/lib/telemetry';
import { useMutation } from '@tanstack/react-query';

import { ClevelandHeartLabSessionUrlDocument } from '@/graphql/generated/graphql';

export function useOpenChlSession(): { open: () => void; isPending: boolean } {
  const { toast } = useToast();
  const tError = useErrorTranslation();

  const mutation = useMutation({
    mutationFn: () => gqlRequest(ClevelandHeartLabSessionUrlDocument, {}),
    onSuccess: (data) => {
      const url = data?.clevelandHeartlabSessionUrl;
      if (url) {
        void openExternalUrl(url);
      }
    },
    onError: (error: unknown) => {
      const code = extractGqlErrorCode(error);
      if (error instanceof Error) {
        trackException(error, { source: 'chlSessionUrl', errorCode: code });
      }
      toast({ title: tError('title'), description: tError(code), variant: 'destructive' });
    },
  });

  return { open: () => mutation.mutate(), isPending: mutation.isPending };
}
